<template>
  <div>
    <v-dialog v-model="open" max-width="900" persistent>
      <v-card>
        <v-sheet color="grey lighten-2" elevation="1">
          <v-card-title class="d-flex justify-space-between">
            <div >
              <span class="headline">Cadastro de Imóvel</span>
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="red"
                  class="white--text"
                  elevation="1"
                  small
                  @click="closeRegisterImmobileForm()"
                >
                  <v-icon dark>close</v-icon>
                </v-btn>
              </template>
              <span>Fechar</span>
            </v-tooltip>
          </v-card-title>
        </v-sheet>

        <v-container>
          <v-card class="px-2" replace outlined elevation="2">
            <v-container>
              <v-form ref="form">
                <v-layout row wrap justify-space-between>
                  <v-col cols="12">
                    <p class="subtitle-1 pb-0 font-weight-bold">Informações Pessoais</p>
                  </v-col>
                  <v-flex xs12 sm4 md4 lg4 xl4>
                    <v-text-field 
                      class="pt-0"
                      v-model="name" 
                      dense 
                      outlined 
                      label="Nome*" 
                      :rules="[rules.required]">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 lg3 xl3>
                    <v-text-field 
                      v-model="telephone" 
                      dense 
                      outlined 
                      label="Telefone*" 
                      :rules="[rules.required]">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4 xl4>
                    <v-text-field 
                      v-model="email" 
                      dense 
                      outlined 
                      label="Email">
                    </v-text-field>
                  </v-flex>
                  <v-col cols="12">
                    <p class="subtitle-1 pb-0 font-weight-bold">Informações do Imóvel</p>
                  </v-col>
                  <v-flex xs12 sm3 md3 lg3 xl3>
                    <v-select 
                      class="pt-0"
                      v-model="immobileFinalityValue"
                      :items="immobileFinality"
                      item-text="name"
                      item-value="id"
                      dense 
                      outlined 
                      label="Finalidade*" 
                      :rules="[rules.required]">
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4 xl4>
                    <v-select 
                      class="pt-0"
                      v-model="immobileTypeValue"
                      :items="immobileTypes"
                      item-text="name"
                      item-value="id"
                      dense 
                      outlined 
                      label="Tipo*" 
                      :rules="[rules.required]">
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4 xl4>
                    <v-text-field 
                      class="pt-0"
                      v-model="immobileValue" 
                      type="number"
                      dense 
                      outlined 
                      label="Valor*" 
                      :rules="[rules.required, rules.notNegative]">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 lg3 xl3>
                    <v-text-field 
                      class="pt-0"
                      v-model="state"
                      dense 
                      outlined 
                      label="Estado">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 lg3 xl3>
                    <v-text-field 
                      class="pt-0"
                      v-model="city"
                      dense 
                      outlined 
                      label="Cidade">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5 md5 lg5 xl5>
                    <v-text-field 
                      class="pt-0"
                      v-model="district"
                      dense 
                      outlined 
                      label="Bairro">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 xl6>
                    <v-text-field 
                      class="pt-0"
                      v-model="address"
                      dense 
                      outlined 
                      label="Endereço">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2 md2 lg2 xl2>
                    <v-text-field 
                      class="pt-0"
                      v-model="number"
                      dense 
                      outlined 
                      :rules="[rules.notNegative]"
                      label="Número">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 lg3 xl3>
                    <v-text-field 
                      class="pt-0"
                      v-model="cep"
                      dense 
                      outlined 
                      :rules="[rules.notNegative]"
                      label="CEP">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-textarea 
                      v-model="note"
                      outlined
                      label="Observações"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <div class="pt-0 d-flex justify-center" >
                   <div>
                    <vue-recaptcha
                      ref="recaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="sitekey"
                      :loadRecaptchaScript="true">
                    </vue-recaptcha>
                    <div class="d-flex justify-center pt-2">
                      <v-btn
                        color="orange"
                        class="white--text text-capitalize"
                        elevation="1"
                        :loading="loadingSendBtn"
                        @click="sendRegisterImmobile()"
                        :disabled="recaptchaVerify"
                      >
                        <v-icon class="pr-2">send</v-icon>
                        Enviar Cadastro
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-form>
            </v-container>
          </v-card>
          <v-spacer class="pt-12"></v-spacer>
          <v-card>
            <v-card-title>
              Informações de contato
            </v-card-title>
            <v-card-text>

              <v-layout row wrap justify-start align-start>
                <p>
                  <v-icon color="blue">place</v-icon>
                  {{ contacStreet }} {{ contacNumber }}, {{ contacDistrict }}, {{ contacCity }}/{{ contacState }} CEP {{ contacZip }}
                </p>
              </v-layout>
              <v-layout row wrap justify-start>
                <v-img src="@/assets/icons/whatsapp.png" max-width="24" min-width="24" max-height="24" min-height="24"></v-img>
                <a target="_blank" rel="noopener noreferrer" :href="callWhatsApp" class="pr-4 pl-1"> {{ contacWhatsapp }} </a>
                <v-row>
                  <p class="pl-4">
                    <v-icon color="grey">call</v-icon>
                    {{ contactPhone }}
                  </p>
                </v-row>
              </v-layout>
              <v-layout class="pt-3" row wrap justify-start>
                <p>
                  <v-icon color="grey">mail</v-icon>
                  <a :href="sendEmail"> {{ contacEmail }}</a>
                </p>
              </v-layout>
            </v-card-text>
          </v-card>

        </v-container>
      </v-card>
    </v-dialog>
    <Snackbar :show="openSnackbar" :message="messageSnackbar" :color="colorSnackbar" />
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import apiState from '@/ilios.store'
import Snackbar from '@/components/Global/Snackbar'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'RegisterImmobileForm',

  props:{
    open:{
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Snackbar,
    VueRecaptcha
  },

  data: () => ({
    sitekey: '',
    recaptchaVerify: true,
    name: null,
    email: null,
    telephone: null,
    immobileFinalityValue: null,
    immobileTypeValue: null,
    immobileValue: null,
    state: null,
    city: null,
    district: null,
    address: null,
    number: null,
    cep: null,
    note: null,
    loadingSendBtn: false,
    openSnackbar: false,
    messageSnackbar: '',
    colorSnackbar: '',
    recaptchaToken: '',
    immobileFinality: [{id: 1, name: "Venda"},
                       {id: 2, name: "Locação"},
                       {id: 3, name: "Ambos"}],
    immobileTypes: [{id: 1, name: "Casa"}, 
                    {id: 2, name: "Kitnet"}, 
                    {id: 3, name: "Sobrado"}, 
                    {id: 4, name: "Apartamento"}, 
                    {id: 5, name: "Sobreloja"}, 
                    {id: 6, name: "Terreno"},
                    {id: 7, name: "Sala"}, 
                    {id: 8, name: "Loja"}],
    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      maxSize: value => !value || value.size < 100000 || 'O tamanho máximo permitido do icone é de 100kb',
      notNegative: value => value > -1 || 'Valor do campo inválido.',
    },
  }),

  mounted() {
    this.sitekey = process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
  },

  computed: {

    ...mapState('Company', {
      contactPhone: 'companyPhone',
      contacWhatsapp: 'companyWhatsApp',
      contacEmail: 'companyEmail',
      contacStreet: 'companyStreet',
      contacZip: 'companyZip',
      contacNumber: 'companyNumber',
      contacDistrict: 'companyDistrict',
      contacCity: 'companyCity',
      contacState: 'companyState',
    }),

    callWhatsApp() {
      return 'https://api.whatsapp.com/send?phone=' + this.contacWhatsapp;
    },

    sendEmail() {
      return 'mailto:' + this.contacEmail;
    }
  },

  watch: {

  },

  methods: {
    ...mapActions({
      postRegisterImmobile: 'Immobile/postRegisterImmobile'
    }),

    ...mapGetters({
  
    }),

    onVerify: function (response) {
     if (response){
       this.recaptchaVerify = false
       this.recaptchaToken = response
     }
    },

    onExpired: function () {
      this.recaptchaVerify = true
    },
    
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },

    async sendRegisterImmobile(){
      if (this.$refs.form.validate()){
        this.loadingSendBtn = true
        var data = {
          name: this.name + " (WebSite)",
          planned_revenue: this.immobileValue,
          email_from: this.email,
          phone: this.telephone,
          finalidade_imovel: this.immobileFinalityValue,
          partner_name: this.name,
          street: this.district,
          street2: this.address + ", " + this.number,
          city: this.city,
          state_char: this.state,
          zip: this.cep,
          description: this.note,
          recaptchaToken: this.recaptchaToken
        }
        var result = await this.postRegisterImmobile({
          data: data
        })
        if (result){
          this.messageSnackbar = 'Operação realizada com sucesso!'
          this.colorSnackbar = 'success'
        }
        else{
          this.messageSnackbar = 'Ocorreu um erro durante a operação.'
          this.colorSnackbar = 'error'
        }
        this.openSnackbar = true
        this.closeRegisterImmobileForm()
        this.loadingSendBtn = false
        this.resetRecaptcha()
      }
    },

    cleanForm(){
      this.name = null
      this.email = null
      this.telephone = null
      this.immobileFinalityValue = null
      this.immobileTypeValue = null
      this.immobileValue = null
      this.state = null
      this.city = null
      this.district = null
      this.address = null
      this.number = null
      this.cep = null
      this.note = null
    },

    closeRegisterImmobileForm(){
      this.cleanForm()
      this.$emit('closeRegisterImmobileForm')
    },

  },
};
</script>